import { useQueryApi } from 'utils/api'
import { handleCommonErrors } from 'utils/api'

import type { CertificateStatusType } from './types'
import type { CommonListResponse, CommonResponse } from 'types/api'
import type { OverallProgress } from 'types/microlearning'

const basePath = '/microlearnings'

export function useGetTopicsProgress(isTriggered: boolean) {
  return useQueryApi<CommonListResponse<OverallProgress>>(
    `${basePath}/topics/progress`,
    {
      queryConfig: {
        enabled: isTriggered,
        useErrorBoundary: false,
      },
      errorHandlerFn: (status, path, error) => {
        handleCommonErrors(status ?? 500, path, error)
      },
    }
  )
}

export function useGetSingleTopicProgress(
  moduleId: string,
  isTriggered: boolean
) {
  return useQueryApi<
    CommonResponse<
      OverallProgress,
      { certifiable?: boolean; certificateStatus?: CertificateStatusType }
    >
  >(`${basePath}/topics/${moduleId}/progress`, {
    queryConfig: {
      enabled: !!moduleId && isTriggered,
    },
    errorHandlerFn: (status, path, error) => {
      handleCommonErrors(status ?? 500, path, error)
    },
  })
}
